export default {
  QUESTION: 'question',
};



// WEBPACK FOOTER //
// ./src/component/peerReview/ItemTypes.js